export default __webpack_public_path__ + "static/media/WATCH-BNB.7ec13323.svg";